import axios from 'axios';
import { getMicroServiceUrl } from '../helpers';

export const getUnifiedLabel = () => {
  return {
    type: 'GET_LABEL_DATA',
    payload: axios.get(`${getMicroServiceUrl('data')}uwl`),
  };
};
